import type React from 'react';

import Button, { type ButtonProps } from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import { colors, fonts } from '../../styles';

interface HoverButtonProps extends ButtonProps {
  hovered?: boolean;
  loading?: boolean;
}

export const HoverButton: React.FC<HoverButtonProps> = (props) => {
  const { children, hovered, loading, ...otherProps } = props;

  const ButtonWithStyle = withStyles({
    root: {
      boxShadow: 'none',
      textTransform: 'none',
      padding: '11.5px 10px',
      lineHeight: '17px',
      boxSizing: 'border-box',
      backgroundColor: hovered ? colors.gray.lightest : 'transparent',
      display: 'flex',
      color: hovered ? colors.primary.hover : colors.primary.default,
      alignItems: 'center',
      '&:hover': {
        backgroundColor: colors.gray.lightest,
        color: colors.primary.hover,
      },
      '&:disabled': {
        cursor: 'not-allowed',
        pointerEvents: 'auto',
      },
    },
    label: {
      color: 'currentColor',
      fontSize: fonts.size.small,
      fontWeight: fonts.weight.bold,
      letterSpacing: 'normal',
    },
    disabled: {
      opacity: loading ? 'unset' : 0.4,
      backgroundColor: colors.gray.lightest,
      borderRadius: '5px',
      cursor: 'not-allowed',
      pointerEvents: 'none',
      '&&': {
        color: colors.primary.default,
      },
    },
  })(Button);

  return (
    <ButtonWithStyle {...otherProps} disableRipple>
      {children}
    </ButtonWithStyle>
  );
};

export default HoverButton;
